/**
 * @generated SignedSource<<7a44f1d172a028426a3a91dd769d45ff>>
 * @relayHash 3e1b8ad99323925f7f9acd3b0a8da699
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 578f8900b035c8aabb9585b20ffa9eba064b10f20e4fb991d7f807712f2538f9

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ContentTypesHeaderQuery$variables = {
  contentId?: string | null | undefined;
  useObjectHeader: boolean;
};
export type ContentTypesHeaderQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly draftVersion?: {
        readonly contentTypeModified: boolean | null | undefined;
        readonly friendlyWhen: string | null | undefined;
        readonly number: number | null | undefined;
      } | null | undefined;
      readonly operations: ReadonlyArray<{
        readonly operation: string | null | undefined;
        readonly targetType: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly space: {
        readonly " $fragmentSpreads": FragmentRefs<"useContentSpaceFragment">;
      } | null | undefined;
      readonly version?: {
        readonly contentTypeModified: boolean | null | undefined;
        readonly friendlyWhen: string | null | undefined;
        readonly number: number | null | undefined;
      } | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"useContentBasicInfoFragment">;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type ContentTypesHeaderQuery = {
  response: ContentTypesHeaderQuery$data;
  variables: ContentTypesHeaderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "useObjectHeader"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  },
  {
    "kind": "Literal",
    "name": "status",
    "value": [
      "archived",
      "current",
      "draft"
    ]
  }
],
v2 = {
  "concreteType": "OperationCheckResult",
  "kind": "LinkedField",
  "name": "operations",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "operation"
    },
    {
      "kind": "ScalarField",
      "name": "targetType"
    }
  ]
},
v3 = [
  {
    "kind": "ScalarField",
    "name": "contentTypeModified"
  },
  {
    "kind": "ScalarField",
    "name": "number"
  },
  {
    "kind": "ScalarField",
    "name": "friendlyWhen"
  }
],
v4 = {
  "condition": "useObjectHeader",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "Version",
      "kind": "LinkedField",
      "name": "version",
      "plural": false,
      "selections": (v3/*: any*/)
    },
    {
      "concreteType": "Version",
      "kind": "LinkedField",
      "name": "draftVersion",
      "plural": false,
      "selections": (v3/*: any*/)
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ContentTypesHeaderQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "useContentBasicInfoFragment"
              },
              {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "useContentSpaceFragment"
                  }
                ]
              },
              (v2/*: any*/),
              (v4/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContentTypesHeaderQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "ScalarField",
                "name": "title"
              },
              {
                "kind": "ScalarField",
                "name": "type"
              },
              {
                "kind": "ScalarField",
                "name": "subType"
              },
              {
                "kind": "ScalarField",
                "name": "status"
              },
              {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "key"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "alias"
                  }
                ]
              },
              (v2/*: any*/),
              (v4/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "3e1b8ad99323925f7f9acd3b0a8da699",
    "id": "578f8900b035c8aabb9585b20ffa9eba064b10f20e4fb991d7f807712f2538f9",
    "metadata": {},
    "name": "ContentTypesHeaderQuery",
    "operationKind": "query",
    "text": "query ContentTypesHeaderQuery($contentId:ID,$useObjectHeader:Boolean!){content(id:$contentId,status:[\"archived\",\"current\",\"draft\"]){nodes{...useContentBasicInfoFragment,space{...useContentSpaceFragment,id},operations{operation,targetType},version@include(if:$useObjectHeader){contentTypeModified,number,friendlyWhen}\n      draftVersion@include(if:$useObjectHeader){contentTypeModified,number,friendlyWhen},id}}}fragment useContentBasicInfoFragment on Content{id,title,type,subType,status}fragment useContentSpaceFragment on Space{id,name,key,alias}"
  }
};
})();

(node as any).hash = "b00a2b355a74b39fcbb57135227bc5cf";

export default node;
